module.exports = __webpack_public_path__ + "img/salary_logo.2e7c8a98.png";